import React from "react"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import SlugTable from "../utils/SlugTable"

const AdminOrgUserRpt = () => {
  return (
    <div>
      <h1>Org User Report</h1>
      <SlugTable mode='myDomain' />
    </div>
  )
}

export default AdminOrgUserRpt